import { bn } from './bn'
import { en } from './en'
import { es } from './es'
import { fil } from './fil'
import { id } from './id'
import { ja } from './ja'
import { km } from './km'
import { my } from './my'
import { ne } from './ne'
import { pt } from './pt'
import { si } from './si'
import { th } from './th'
import { vi } from './vi'
import { zhCN } from './zh-CN'
import { zhTW } from './zh-TW'

/**
 * 固定UI文言用の namespace 名。動的翻訳の 'translation' namespace と分離する。
 */
export const STATIC_NAMESPACE = 'static'

/**
 * i18next に登録する言語ごとの resource 辞書。
 *
 * key: 言語コード。{@link ../../components/domain/LanguageSelectionContent}
 *      の `languages` 配列と対応する。
 * value: { [STATIC_NAMESPACE]: 翻訳辞書 } 形式。
 */
export const staticResources = {
  ja: { [STATIC_NAMESPACE]: ja },
  en: { [STATIC_NAMESPACE]: en },
  'zh-CN': { [STATIC_NAMESPACE]: zhCN },
  'zh-TW': { [STATIC_NAMESPACE]: zhTW },
  vi: { [STATIC_NAMESPACE]: vi },
  fil: { [STATIC_NAMESPACE]: fil },
  th: { [STATIC_NAMESPACE]: th },
  pt: { [STATIC_NAMESPACE]: pt },
  id: { [STATIC_NAMESPACE]: id },
  ne: { [STATIC_NAMESPACE]: ne },
  es: { [STATIC_NAMESPACE]: es },
  my: { [STATIC_NAMESPACE]: my },
  bn: { [STATIC_NAMESPACE]: bn },
  si: { [STATIC_NAMESPACE]: si },
  km: { [STATIC_NAMESPACE]: km },
}
